import { SearchBaseModel } from '../commonModels';
import { DateRange } from '../commonModels';
import { OrderSearchModel } from '../order/orderSearch';
export class RelocationOrderSearchModel extends OrderSearchModel {

  constructor() {
    super();

    this.DpdOrderNumber = null;
    this.IsRelocationOtherDestinationAddress = null;
    this.RelocationIsOtherSource = null;
    this.IsRelocationDestinationCar = null;
    this.ExludedOrderStatusId = new Array();
    this.RelocationDestinationGarageName = null;
    this.RelocationDestinationGarageId = null;
  }

  public DpdOrderNumber: string;
  public IsRelocationOtherDestinationAddress: boolean;

  public RelocationIsOtherSource: boolean;
  public IsRelocationDestinationCar: boolean;
  public ExludedOrderStatusId: number[];

  public RelocationDestinationGarageName: string;
  public RelocationDestinationGarageId: number;
  public CarId: number;
}

